import { render } from "./AbrechnungList.vue?vue&type=template&id=56b4b8d4"
import script from "./AbrechnungList.vue?vue&type=script&lang=js"
export * from "./AbrechnungList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__